import { Link as RRLink } from 'react-router-dom';

/**
 * Thin wrapper around React Router's `<Link>` that automatically stops
 * event propagation on click. Prevents double navigation when used
 * inside a ClickableRow or any other parent with a click handler.
 *
 * @param {{ children: import('react').ReactNode, to: string, onClick?: (e: MouseEvent) => void, className?: string, [key: string]: any }} props
 * @returns {JSX.Element}
 */
export function Link({ onClick, ...props }) {
	return (
		<RRLink
			{...props}
			onClick={(e) => {
				e.stopPropagation();
				onClick?.(e);
			}}
		/>
	);
}
